import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, LayoutDashboard, AlertCircle } from '../components/icons';

export function RespondentWelcomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen freud-bg py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="flex justify-center mx-auto mb-6">
            <img src="/human_potential_os_logo_V2_cropped.png" alt="NLP OS" className="h-16 w-auto" />
          </div>
          <h1 className="freud-display-sm text-chocolate-900 mb-4">
            Welcome! Your Account Is Ready
          </h1>
          <p className="freud-text-lg text-chocolate-500">
            You're all set up. Here's what you can do next.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <motion.button
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.15 }}
            onClick={() => navigate('/instructions')}
            className="freud-card-elevated p-8 text-left hover:shadow-lg transition-shadow group"
          >
            <div className="p-3 bg-sage-100 rounded-xl w-fit mb-4">
              <ArrowRight className="w-6 h-6 text-sage-600" />
            </div>
            <h3 className="freud-heading-lg text-chocolate-900 mb-2">
              Start My Assessment
            </h3>
            <p className="freud-text-base text-chocolate-600">
              Jump straight into your assessment. It takes about 20-30 minutes to complete.
            </p>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-sage-600 mt-4 group-hover:gap-2.5 transition-all">
              Begin now <ArrowRight className="w-4 h-4" />
            </span>
          </motion.button>

          <motion.button
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.25 }}
            onClick={() => navigate('/dashboard')}
            className="freud-card-elevated p-8 text-left hover:shadow-lg transition-shadow group"
          >
            <div className="p-3 bg-cream-200 rounded-xl w-fit mb-4">
              <LayoutDashboard className="w-6 h-6 text-chocolate-600" />
            </div>
            <h3 className="freud-heading-lg text-chocolate-900 mb-2">
              Go to My Dashboard
            </h3>
            <p className="freud-text-base text-chocolate-600">
              Explore your client dashboard first. You can start the assessment whenever you're ready.
            </p>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-chocolate-600 mt-4 group-hover:gap-2.5 transition-all">
              Enter dashboard <ArrowRight className="w-4 h-4" />
            </span>
          </motion.button>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="bg-sand-100 border border-sand-300 rounded-2xl p-6 flex items-start gap-4"
        >
          <div className="p-2.5 bg-sand-200 rounded-xl flex-shrink-0">
            <AlertCircle className="w-5 h-5 text-sand-800" />
          </div>
          <div>
            <p className="freud-text-base text-sand-900 font-medium mb-1">
              No rush -- the assessment is always there for you
            </p>
            <p className="freud-text-sm text-sand-800">
              You can start your assessment at any time from your dashboard. Take a moment to
              look around first if you prefer -- nothing will expire or disappear.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
